/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const StorageInvoiceStatus = {
    CANCELLED: 'CANCELLED',
    REJECTED: 'REJECTED',
    SENT: 'SENT',
    NEW: 'NEW',
    ACCEPTED: 'ACCEPTED'
} as const;
export type StorageInvoiceStatus = typeof StorageInvoiceStatus[keyof typeof StorageInvoiceStatus];

